module.exports = __webpack_public_path__ + "img/GLOBAL_VEGETABLE_OILS.5e27da47.png";